import { render } from "./SuperAdminPatientsActions.vue?vue&type=template&id=380587fa"
import script from "./SuperAdminPatientsActions.vue?vue&type=script&lang=js"
export * from "./SuperAdminPatientsActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__